import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './style.css';

export default function Cancel() {
  return (
    <section className="cancel-section">
      <Container>
        <Row className="justify-content-center">
          <Col md="8">
            <div className="cancel-content text-center">
              <h1 className="cancel-title">Pago Cancelado</h1>
              <div className="cancel-description">
                No hemos podido procesar tu pago. Verifica tu medio de pago e intente nuevamente.
              </div>
              <div className="cancel-buttons mt-4">
                <a href="./" className="btn btn-outline-danger">
                  Volver a la página principal
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
